import Vue from "vue";

import comboComponent from "@/components/child/form/combo.vue";
import { Component, Prop, Watch } from "@/decorators";
import FormulaPadraoManipulacaoModel from "@/models/formulaPadraoManipulacaoModel";
import FormulaPadraoModel from "@/models/formulaPadraoModel";
import ManipulacaoOrdemModel from "@/models/manipulacaoOrdemModel";
import FormulaPadraoManipulacaoService from "@/services/formulaPadraoManipulacaoService";
import formulaPadraoService from "@/services/formulaPadraoService";

@Component({
    components: {
        comboComponent,
    },
})
export default class PreVendaComponent extends Vue {
    @Prop(Number) estoqueId: number;

    serviceFormPadraoManipulacao = new FormulaPadraoManipulacaoService();
    formulaPadraoOptions: Array<Object> = [];
    modelArray: Array<FormulaPadraoManipulacaoModel> = [];
    formulasPadrao: Array<FormulaPadraoModel> = [];

    public formulapadraoId: number = null;
    public formulaPadraoFranquiaId: number = null;

    public async onAdicionarFormulaPadrao(estoqueId: number) {
        const isValid = await this.$validator.validateAll();
        if (isValid) {
            const response = await this.convertFormPadraoEmManipulacao(estoqueId).withLoading();

            if (response) {
                this.$emit("inclusao-item", response);
                this.clear();
                return true;
            }
        }

        return false;
    }

    private async clear() {
        this.formulapadraoId = null;
    }

    private async loadFormulasPadrao() {
        try {
            this.formulasPadrao = await formulaPadraoService
                .listPreVendaFormulaPadrao(this.estoqueId)
                .resolveWithJSON<FormulaPadraoModel[]>();
            this.formulaPadraoOptions = this.formulasPadrao.map(p => ({ value: p.id, text: p.descricao }));
        } catch {}
    }

    private async convertFormPadraoEmManipulacao(estoqueId: number) {
        try {
            const data = await formulaPadraoService
                .getByFranquia(this.formulapadraoId, this.formulaPadraoFranquiaId)
                .resolveWithJSON<FormulaPadraoModel>();

            const manipulacao = await this.serviceFormPadraoManipulacao
                .convertFormulaPadraoEmManipulacao(data, estoqueId)
                .resolveWithJSON<ManipulacaoOrdemModel>();

            manipulacao.isPreVendaEditavel = data.edicaoPreVenda;
            manipulacao.homeopatia = manipulacao.itens.some(s => s.tipoCalculo > 5 && s.tipoCalculo < 8);
            manipulacao.itens.forEach(p => {
                p.produtoDescricao = p.produto.descricao;
            });
            return manipulacao;
        } catch {}

        return false;
    }

    private async onAlertQuantidadeInsuficiente(
        produto: string,
        msgFinal = " foi alterado a quantidade para a maxima disponivel.",
    ) {
        await this.$showError(
            this.$t("__.ts.atencao") as string,
            (this.$t("__.ts.naoHaQtd") as string) + produto + msgFinal,
        );
    }

    @Watch("formulapadraoId")
    private async onFormulaPadraoChange() {
        if (this.formulapadraoId) {
            const formulaSelecionada = this.formulasPadrao.find(p => p.id === this.formulapadraoId);
            this.formulaPadraoFranquiaId = formulaSelecionada.franquiaId;
        }
    }

    async mounted() {
        await this.clear();
        await this.loadFormulasPadrao();
    }
}
